module.exports = __webpack_public_path__ + "img/icon-automation.9592e7a0.svg";